import { slugify } from './slugify'

export const constantify = (text: string): string =>
  slugify(text).toUpperCase().replace(/-/g, '_')
